import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { format } from 'date-fns';
import { id as localeId } from 'date-fns/locale';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export const options = {
  responsive: true,

  plugins: {
    legend: {
      display: false
    },
    title: {
      display: false
    },

    tooltips: {
      position: 'nearest',
      mode: 'index',
      intersect: false,
      yPadding: 10,
      xPadding: 10,
      caretSize: 4,
      backgroundColor: '#1967d2',
      borderColor: 'rgba(0,0,0,1)',
      borderWidth: 4
    }
  }
};
const labels = ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min'];

const ChartMain = ({ incomes }) => {
  const incomeDataByDay = labels.reduce((acc, day) => {
    acc[day] = 0;
    return acc;
  }, {});

  incomes.forEach((income) => {
    const dayName = format(new Date(income.created_at), 'eee', { locale: localeId });
    const dayLabel = labels.find((label) => dayName.toLowerCase().startsWith(label.toLowerCase()));
    if (dayLabel) {
      incomeDataByDay[dayLabel] += income.amount;
    }
  });

  const data = {
    labels,
    datasets: [
      {
        label: 'Income',
        data: labels.map((day) => incomeDataByDay[day]),
        borderColor: '#1967d2',
        backgroundColor: '#1967d2',
        fill: false
      }
    ]
  };

  return (
    <div className="widget-content mt-20">
      <Line options={options} data={data} />
    </div>
  );
};

export default ChartMain;
